/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WageListIdentificationType {
    All = '0',
    SpecificContact = 1,
}
